import Heading from 'LuxKit/Typography/Heading'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import clsx from 'clsx'
const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  &.has-image{
    justify-content: flex-start;
  }
`

interface Props {
  holidayType: string
  destination: string
  hasImage: boolean
}

export function ResultsFilteredByHolidayTypeAndDestination({ holidayType, destination, hasImage }: Props) {
  return (
    <Container className={clsx({ 'has-image': hasImage })}>
      <Heading as="span" colour="neutral-eight" variant="heading1">
        <FormattedMessage
          id="ImgZRzhztcVFYSgpAOgJ"
          defaultMessage="<i>{holidayType}</i> travel inspiration in <i>{destination}</i>"
          description="Hero heading for holiday type landing page filtered by both holiday type and destination"
          values={{
            holidayType,
            destination,
            i: (chunks) => <i>{chunks}</i>,
          }}
        />
      </Heading>
    </Container>
  )
}
